module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAABDUlEQVQoU5WSv0oDQRDGv28vYMSAL6GlCpGLKAHxCVIJVmL8c4iFhZ29dYoUkhxGxUrsfAIRDg05ELT2JYSIBnI3MrALZ+6abDPwzXw7v5ldwp7lO5mb+cUpgYYAY5UJlAR4HJXR/tjlt9WA6pUseCnuAVyXhrh5PeOPJtdbMjuuoAlgPzHYeTvkJ+3Nz0xxMDjmuxb6oWxojAO+aKx1ZEUMeqMyNumHcg7gKw546fD8UPas4TajnQCYZy2UvjfElsOwHXIGxUsqeNIOURyw7m5yBhLe4Ii9CT0qNKx1ZDE1eEgMtnXQDFZUiKQFq11ZMsRFHLDhNuaQckNnMXJDF6110vBvrZqc6uGm/Rp/kdyVoVV2cfAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/fbsj.png
// module id = ZnkZ
// module chunks = 1